import featureFlags from "@/utils/feature-flags";

export const applePayPossible = () => {
  if (!featureFlags.enabled("apple_pay")) {
    return;
  }

  if (!window.ApplePaySession) {
    return;
  }

  try {
    const canMakePayments = window.ApplePaySession.canMakePayments();

    return canMakePayments;

  } catch (error) {
    // Apple pay failed to initialise
    console.log(error); /* eslint-disable-line */
  }
};
